import { useTranslation } from 'react-i18next';
import { Widget, WidgetProps } from '../widget';
import CompleteRate from './CompleteRate.component';
import { useHomeControllerGetCompleteRatesQuery } from '@/store/services/MidleNestApi.service';

export default function TasksCompletingRates({ ...props }: WidgetProps) {
  const { t } = useTranslation();
  const { data } = useHomeControllerGetCompleteRatesQuery();

  return (
    <Widget title={t('Active Tasks Completing Rates')} className='' loading={false} {...props}>
      <div className='grid grid-cols-2 md:grid-cols-3'>
        <CompleteRate
          title={t('Active Connection Tasks')}
          value={
            data?.connectionCompleted && data?.connectionCount
              ? (data.connectionCompleted / data.connectionCount) * 100
              : 0
          }
          strokeColor='#34B53A'
          fillColor='#E2FBD7'
          className='p-2 sm:p-4 md:p-6'
        />

        <CompleteRate
          title={t('Active Tasks')}
          value={
            data?.tasksCompleted && data?.tasksCount
              ? (data.tasksCompleted / data.tasksCount) * 100
              : 0
          }
          strokeColor='#4339F2'
          fillColor='#DAD7FE'
          className='p-2 sm:p-4 md:p-6'
        />

        <CompleteRate
          title={t('Active Campaigns')}
          value={
            data?.campaignCompleted && data?.campaignCount
              ? (data.campaignCompleted / data.campaignCount) * 100
              : 0
          }
          strokeColor='#4339F2'
          fillColor='#DAD7FE'
          className='p-2 sm:p-4 md:p-6'
        />
      </div>
    </Widget>
  );
}
